import { useContext, useEffect, useState } from "react";
import { isValidArray } from "../../Layout/Common/common";
import { ProductCardAlgolia } from "../../Layout/Common/productCardAlgolia";
import { GlobalContext } from "../../Context/GlobalContext";
import { PAGES } from "../../routeConfig";
import { Link } from "react-router-dom";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";

export const NewProductAlgolia = () => {
  const { algoliaProducts } = useContext(GlobalContext);
  const [productHit, setProductHit] = useState();
  useEffect(() => {
    if (algoliaProducts && isValidArray(algoliaProducts["NEWPRODUCTS"])) {
      setProductHit(algoliaProducts["NEWPRODUCTS"]);
    } else {
      //fetchNewProductsAlgolia();
    }
  }, [algoliaProducts]);

  return (
    <section className="products-section">
      <div className="container-fluid container-lg">
        <div className="row">
          <div className="col-md-12">
            <div className="section-title">
              <h2>New Products</h2>
              <Link to={PAGES.NEWPRODUCTS_CT} className="text-decoration-underline text-uppercase">
                View All
              </Link>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="row row-spacing">
              {isValidArray(productHit) &&
                productHit.slice(0, 8).map((item, idx) => (
                  <div className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3 mt-lg-4" key={item.key ?? `new-${idx}`}>
                    <ProductCardAlgolia data={item} />
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
